import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { registerCNUIPlugin, checkElementInDialog } from "./utils";
var pluginName = "CnFilterPro-auto-enhance-with-cn-arms";
var injectComponentName = "CnFilterPro";
var startInputTime = 0;
export var extendCnFilterProProps = function(props, core) {
    var _newProps_onChange, _newProps_onSubmit;
    var onChange = props.onChange, onSubmit = props.onSubmit, schema = props.schema, ref = props.ref;
    var newProps = _object_spread({}, props);
    var filterRef = ref;
    if (((_newProps_onChange = newProps.onChange) === null || _newProps_onChange === void 0 ? void 0 : _newProps_onChange.__inject_with_cn_arms) !== true) {
        newProps.onChange = function(value, event) {
            for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
                args[_key - 2] = arguments[_key];
            }
            if (typeof onChange === "function" && onChange.__inject_with_cn_arms !== true) {
                onChange.apply(void 0, [
                    value,
                    event
                ].concat(_to_consumable_array(args)));
            }
            try {
                var _filterRef, _event;
                var element = ((_filterRef = filterRef) === null || _filterRef === void 0 ? void 0 : _filterRef.current) || ((_event = event) === null || _event === void 0 ? void 0 : _event.target);
                if (checkElementInDialog(element)) {
                    return;
                }
                var currentTime = new Date().getTime();
                // 如果是第一次输入，或者间隔大于 2分钟，重新记录开始时间
                if (startInputTime === 0 || currentTime - startInputTime > 120000) {
                    var _filterRef1;
                    startInputTime = currentTime;
                    if ((_filterRef1 = filterRef) === null || _filterRef1 === void 0 ? void 0 : _filterRef1.current) {
                        filterRef.current._startInputTime = startInputTime;
                    }
                }
            } catch (err) {
            // ignore error
            }
        };
        newProps.onChange.__inject_with_cn_arms = true;
    }
    if (((_newProps_onSubmit = newProps.onSubmit) === null || _newProps_onSubmit === void 0 ? void 0 : _newProps_onSubmit.__inject_with_cn_arms) !== true) {
        newProps.onSubmit = function(values, event) {
            for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
                args[_key - 2] = arguments[_key];
            }
            if (typeof onSubmit === "function" && onSubmit.__inject_with_cn_arms !== true) {
                onSubmit.apply(void 0, [
                    values,
                    event
                ].concat(_to_consumable_array(args)));
            }
            try {
                var _filterRef, _event, _values, _filterRef_current, _filterRef1;
                var element = ((_filterRef = filterRef) === null || _filterRef === void 0 ? void 0 : _filterRef.current) || ((_event = event) === null || _event === void 0 ? void 0 : _event.target);
                if (checkElementInDialog(element)) {
                    return;
                }
                var nameMap = {};
                var isOneSearch = ((_values = values) === null || _values === void 0 ? void 0 : _values.one_search_flag) === true;
                var properties = typeof schema === "object" ? schema.properties || {} : {};
                var allFields = isOneSearch ? [] : Object.keys(properties).map(function(fieldName) {
                    var _properties_fieldName;
                    if (!nameMap[fieldName]) nameMap[fieldName] = properties[fieldName];
                    return {
                        key: fieldName,
                        label: (_properties_fieldName = properties[fieldName]) === null || _properties_fieldName === void 0 ? void 0 : _properties_fieldName.title
                    };
                });
                var selectedTagsItems = typeof ((_filterRef1 = filterRef) === null || _filterRef1 === void 0 ? void 0 : (_filterRef_current = _filterRef1.current) === null || _filterRef_current === void 0 ? void 0 : _filterRef_current.getSelectedTagsItems) === "function" ? filterRef.current.getSelectedTagsItems() : [];
                var filterFields = isOneSearch ? [] : Object.keys(values || {}).filter(function(fieldName) {
                    // 过滤没有值的字段
                    var value = values[fieldName];
                    if (value === undefined || value === null) {
                        return false;
                    }
                    if (Array.isArray(value) && value.length === 0) {
                        return false;
                    }
                    if (typeof value === "string" && value.trim() === "") {
                        return false;
                    }
                    return true;
                }).map(function(fieldName) {
                    var _selectedTagItem, _nameMap_fieldName;
                    var selectedTagItem = (selectedTagsItems || []).find(function(item) {
                        return item && item.key === fieldName && item.valueText;
                    });
                    var valueText = (_selectedTagItem = selectedTagItem) === null || _selectedTagItem === void 0 ? void 0 : _selectedTagItem.valueText;
                    var inputLabels = [];
                    if (typeof valueText === "string" && valueText.length > 0) {
                        if (valueText.indexOf(", ") > -1) {
                            inputLabels = valueText.split(", ");
                        } else if (valueText.indexOf(" ~ ") > -1) {
                            inputLabels = valueText.split(" ~ ");
                        } else {
                            inputLabels = [
                                valueText
                            ];
                        }
                    }
                    return {
                        key: fieldName,
                        label: (_nameMap_fieldName = nameMap[fieldName]) === null || _nameMap_fieldName === void 0 ? void 0 : _nameMap_fieldName.title,
                        inputLabels: inputLabels
                    };
                });
                var currentTime = new Date().getTime();
                if (allFields.length > 0 || isOneSearch) {
                    var _filterRef_current1, _filterRef2;
                    var spendTime = 0;
                    var currentStartInputTime = ((_filterRef2 = filterRef) === null || _filterRef2 === void 0 ? void 0 : (_filterRef_current1 = _filterRef2.current) === null || _filterRef_current1 === void 0 ? void 0 : _filterRef_current1._startInputTime) || startInputTime;
                    if (currentStartInputTime > 0) {
                        spendTime = Math.ceil((currentTime - currentStartInputTime) / 1000);
                    }
                    var logItem = {
                        p1: "cone-ftp-filter-report-v2",
                        p2: isOneSearch ? "oneSearch" : "cnFilter",
                        p3: isOneSearch ? undefined : JSON.stringify(allFields),
                        p4: isOneSearch ? undefined : JSON.stringify(filterFields),
                        p5: spendTime,
                        p6: isOneSearch ? undefined : allFields.filter(function(item) {
                            return item && filterFields.find(function(filterItem) {
                                return filterItem && item.key === filterItem.key;
                            });
                        }).map(function(item) {
                            return item.label;
                        }).join(","),
                        p7: isOneSearch ? values.bizAccessKey : undefined,
                        p8: isOneSearch ? JSON.stringify(values) : undefined,
                        p9: newProps["data-component-id"]
                    };
                    startInputTime = 0;
                    core.logCustom(logItem);
                }
            } catch (err) {
            // ignore error
            }
        };
        newProps.onSubmit.__inject_with_cn_arms = true;
    }
    if (filterRef) {
        newProps.ref = filterRef;
    }
    return newProps;
};
export var init = function(core) {
    registerCNUIPlugin(injectComponentName, pluginName, function(props, context) {
        var ref = props.ref || {
            current: null
        };
        return {
            props: extendCnFilterProProps(_object_spread_props(_object_spread({}, props), {
                ref: ref
            }), core),
            context: context
        };
    });
};

 //# sourceMappingURL=cn-fliter-enhance.js.map